// extracted by mini-css-extract-plugin
module.exports = {"WasteSaved":"WasteReductionCard__WasteSaved___1A328","WasteSavedValue":"WasteReductionCard__WasteSavedValue___3RH29"};